import { Tuotenimike, tuotenimikkeet } from '@lemon/core-firebase/model/tuotenimikkeet'
import { TuettuKieli } from '@lemon/core/model/common'

export class TuotteetService {
  public async annaTuotenimikeAvaimella(tuoteAvain: string): Promise<Tuotenimike | null> {
    return tuotenimikkeet.find(t => t.avain === tuoteAvain) ?? null
  }

  public async annaTuoteNimiLisatiedoillaKielella(tuoteAvain: string, kieli: TuettuKieli, lisatiedot?: string): Promise<string> {
    const tuotenimike = await this.annaTuotenimikeAvaimella(tuoteAvain)
    if (!tuotenimike) {
      throw new Error('Tuotenimikettä ei löytynyt avaimella: ' + tuoteAvain)
    }
    const tuoteNimi = kieli === 'en' ? tuotenimike.engNimi : tuotenimike.nimi
    return tuoteNimi + (lisatiedot?.trim() ? ': ' + lisatiedot.trim() : '')
  }

  public async annaMuutJatkuvatVeloituksetTuotteet(): Promise<Tuotenimike[]> {
    return tuotenimikkeet.filter(t => t.muuJatkuvaVeloitus)
  }
}
